"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var react_table_1 = require("react-table");
var core_1 = require("@material-ui/core");
var atoms_1 = require("../../atoms");
var molecules_1 = require("../../molecules");
var types_1 = require("./types");
var styles_1 = __importDefault(require("./styles"));
var Cell_1 = require("../../atoms/Cell");
exports.Table = react_1.default.memo(function (_a) {
    var columns = _a.columns, data = _a.data, _b = _a.checkboxes, checkboxes = _b === void 0 ? false : _b, isLoading = _a.isLoading, _c = _a.onRowClick, onRowClick = _c === void 0 ? function () { } : _c, emptyDataText = _a.emptyDataText, _d = _a.variant, variant = _d === void 0 ? types_1.TableVariants.PRIMARY : _d, _e = _a.edit, edit = _e === void 0 ? false : _e, _f = _a.footerColumns, footerColumns = _f === void 0 ? [] : _f, rest = __rest(_a, ["columns", "data", "checkboxes", "isLoading", "onRowClick", "emptyDataText", "variant", "edit", "footerColumns"]);
    var classes = (0, styles_1.default)({
        variant: variant,
    });
    // TODO: move these to the molecules they belong OR style them from the same useStyles
    var checkboxStyles = { padding: 0 };
    var labelStyles = {
        marginRight: 0,
        marginLeft: 0,
    };
    var _g = (0, react_table_1.useTable)(__assign({ columns: columns, data: data }, rest)), getTableProps = _g.getTableProps, headerGroups = _g.headerGroups, rows = _g.rows, prepareRow = _g.prepareRow;
    var tableClasses = (0, react_1.useMemo)(function () {
        var classNames = [classes.table];
        if (edit)
            classNames.push(classes.tableEdit);
        return classNames.join(' ');
    }, [classes.table, classes.tableEdit, edit]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(atoms_1.LoadingIndicator, { loading: isLoading }), data && !isLoading && ((0, jsx_runtime_1.jsx)(core_1.Paper, __assign({ elevation: 3, className: tableClasses, "data-testid": "paper-container" }, { children: (0, jsx_runtime_1.jsx)(core_1.TableContainer, { children: (0, jsx_runtime_1.jsxs)(core_1.Table, __assign({}, getTableProps(), { children: [(0, jsx_runtime_1.jsx)(molecules_1.TableHeader, { checkboxes: checkboxes, tableHeaderCells: columns, headerGroups: headerGroups, defaultSortOrder: "asc", checkboxStyles: checkboxStyles, labelStyles: labelStyles }), (0, jsx_runtime_1.jsx)(molecules_1.TableBody, { columnCount: columns.length, checkboxes: checkboxes, data: rows, prepareRow: prepareRow, checkboxStyles: checkboxStyles, labelStyles: labelStyles, onRowClick: onRowClick, emptyDataText: emptyDataText, edit: edit }), !!footerColumns.length && ((0, jsx_runtime_1.jsx)(core_1.TableFooter, { children: (0, jsx_runtime_1.jsx)(core_1.TableRow, { children: footerColumns.map(function (footerItem) { return ((0, jsx_runtime_1.jsx)(Cell_1.Cell, { children: (0, jsx_runtime_1.jsx)(atoms_1.Text, __assign({ display: "flex", justifyContent: "space-between", size: "small", weight: "semi-bold" }, { children: footerItem.value })) }, footerItem.id)); }) }) }))] })) }) })))] }));
});
